module.exports = __webpack_public_path__ + "static/media/signage-indoor-img52.d95814d3.jpg";